import { render, staticRenderFns } from "./generic-table.vue?vue&type=template&id=43165876&scoped=true"
import script from "./generic-table.vue?vue&type=script&lang=js"
export * from "./generic-table.vue?vue&type=script&lang=js"
import style0 from "./generic-table.vue?vue&type=style&index=0&id=43165876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43165876",
  null
  
)

export default component.exports